import React, { useContext, useEffect, useState, useRef } from "react";
import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  TooltipHost,
} from "@fluentui/react";
import themeContext from "../../../../../context/theme/ThemeContext";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import {
  changeSortDir,
  clearSort,
  handleDropDownClick,
  handleDropDownClickCustom,
} from "../../../helpers/helpingFunctions";
import { t } from "i18next";
import { dropdownStyles } from "../../../helpers/initData";
import { USERTYPES } from "../../../../../constants/Constants";

const SortFilter = () => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    patientNameBadgeShow,
    removeBadgeFromFilter,
    setPatientDetail,
    handleEnterKeyPress,
    setSortGlobal,
    sortGlobal,
    selectedValue,
    changeToDropSorting, setChangeToDropSorting,
    roles
  } = useContext(studylistContext);

  const { themeName } = useContext(themeContext);
  const [isHoveringOnSort, setIsHoveringOnSort] = useState(false);
  const dropdownRef = useRef();
  const onSetFocus = () => dropdownRef?.current?.focus(true);

  const getColumnLabel = (keyStr) => {
    const options = sortOptionsFunction()
    const result = options.find(({ key }) => key === keyStr);
    if(result == null){
      return t("sorting.study-list.assignment-on");
    }
    return result?.text;
  };
  const handleMouseEnter = () => {
    setIsHoveringOnSort(true);
  };

  const handleMouseLeave = () => {
    setIsHoveringOnSort(false);
  };

  const sortOptionsFunction = () => {
    let options = [
      { key: "patient_name", text: t("sorting.study-list.patient-name") },
      { key: "reporting_provider", text: t("sorting.study-list.radiologist") },
      { key: "patient_id", text: t("sorting.study-list.patient-id") },
      { key: "study_date", text: t("sorting.study-list.study-date") },
      { key: "modality_name", text: t("sorting.study-list.modality") },
      { key: "client_name", text: t("sorting.study-list.hospital") },
      { key: "study_description", text: t("sorting.study-list.description") },
      { key: "assignment_created_date", text: t("sorting.study-list.assignment-on") },
    ]
    if (roles[0] === USERTYPES.TYPIST) {
      options = options.filter(option => option.key !== "client_name");
  }
  
    if(selectedValue == "study_3"){
      options.push( { key: "report_submitted_date", text: t("sorting.study-list.reported-date") })
    }
    if(selectedValue == "study_5"){
        options.push({ key: "qc_review", text: t("sorting.study-list.qc-review") })
    }
    if(selectedValue == "study_6"){
      options.push({ key: "qc_fix", text: t("sorting.study-list.qc-fix") })
    }
    if(selectedValue == "study_7"){
      options.push({ key: "qc_review", text: t("sorting.study-list.qc-review") })
      options.push({ key: "qc_verify", text: t("sorting.study-list.qc-verify") })
    }
    if(selectedValue == "study_14"){
      options.push( { key: "review_assigned_date", text: t("sorting.study-list.review-assigned-date") })
    }
    if(selectedValue == "study_15"){
      options.push( { key: "review_completed_date", text: t("sorting.study-list.review-completed-date") })
    }
    if(selectedValue == "study_16"){
      options.push( { key: "evaluation_assigned_date", text: t("sorting.study-list.evaluator-assigned-date") })
    }
    if(selectedValue == "study_17"){
      options.push( { key: "evaluation_completion_date", text: t("sorting.study-list.evaluation-completed-date") })
    }
    if(selectedValue == "study_18"){
      options.push( { key: "requested_date", text: t("sorting.study-list.requested-date") })
    }
    if(selectedValue == "study_19"){
      options.push( { key: "approved_date", text: t("sorting.study-list.approved-date") })
    }
    if(selectedValue == "study_20"){
      options.push( { key: "requested_date2", text: t("sorting.study-list.requested-date") })
    }

    return options;
   
  }

  useEffect(()=>{
      if(changeToDropSorting){
        onSetFocus();
      }
  },[changeToDropSorting])

  const onRenderOption = (option) => {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span style={{ marginRight: "0px",whiteSpace:"nowrap" }}>{option.text}</span>
        <div style={{display:'block',whiteSpace:'nowrap'}}>
          <Icon
            onClick={(e) => {
              e.stopPropagation();
              handleDropDownClickCustom(e, option, setSortGlobal, sortGlobal,setChangeToDropSorting,false)
            }}
            iconName={"SortDown"}
            aria-hidden="true"
          />
          <Icon
            onClick={(e) => {
              e.stopPropagation();
              handleDropDownClickCustom(e, option, setSortGlobal, sortGlobal,setChangeToDropSorting,true)
            }}
            iconName={"SortUp"}
            aria-hidden="true"
          />
        </div>
      </div>
    );
  };



  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          // width:"20%"
        }}
      >
        <p className="sort-search-text">{t("label.sort-by")}</p>
        {changeToDropSorting ? (
          <Dropdown
            componentRef={dropdownRef}
            options={sortOptionsFunction()}
            placeholder="Select"
            onChange={(e, data) =>
              handleDropDownClick(e, data, setSortGlobal, sortGlobal,setChangeToDropSorting)
            }
            styles={dropdownStyles}
            onRenderOption={onRenderOption}
            onDismiss={()=>{setChangeToDropSorting(false)}}
          />
        ) : (
          <div className="study-list-badge-list-view">
            <span className="study-list-badge-text-list-view-no-hover">
              {getColumnLabel(sortGlobal.sortColumn)}
            </span>
            <Icon
              onClick={() => changeSortDir(setSortGlobal, sortGlobal,setChangeToDropSorting)}
              style={{
                cursor: "pointer",
                lineHeight: "2",
                margin: "0px 3px",
                height: "25px",
                width: "20px",
                backgroundColor: `${
                  isHoveringOnSort ? "rgb(134, 158, 181, 0.5)" : ""
                }`,
                borderRadius: "5px",
                transition: "0.3s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              iconName={sortGlobal.sortOrder == "asc" ? "SortUp" : "SortDown"}
              className="ms-fontSize-10 "
            ></Icon>
            <Icon
              onClick={() => clearSort(setSortGlobal, sortGlobal, setChangeToDropSorting)}
              style={{
                cursor: "pointer",
                lineHeight: "2",
              }}
              iconName="ChevronDownMed"
              className="ms-fontSize-10"
            ></Icon>
          </div>
        )}
      </div>
    </>
  );
};

export default SortFilter;
